import React, { useEffect } from "react";
import {
  SHOW_ALL_TIPS_CHOSEN_KEY,
  SHOW_ALL_TIPS_KEY,
  useTipsDisplay,
} from "@/hooks/useTipsDisplay";
import { minTips, totalTips } from "@/utils/vars";
import { Switch } from "@/components/ui/switch";
import { Lock } from "lucide-react";

const TipsDisplayToggle = ({
  forceTopOnly = false,
  lockedMessage = "Upgrade to unlock all tips",
}) => {
  const { showAllTips, toggleTipsDisplay } = useTipsDisplay();
  const isLocked = !!forceTopOnly;
  const effectiveShowAll = isLocked ? false : showAllTips;

  useEffect(() => {
    if (!isLocked) return;
    try {
      // Lexi Social sees the top 2. This is not the person's own choice, so
      // a paid account goes back to all 4 (see useTipsDisplay).
      localStorage.setItem(SHOW_ALL_TIPS_KEY, "false");
      localStorage.removeItem(SHOW_ALL_TIPS_CHOSEN_KEY);
      window.dispatchEvent(new Event("tipsDisplayChanged"));
    } catch {
      // ignore
    }
  }, [isLocked]);

  if(isLocked) return null;

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        <span className={`text-sm ${isLocked ? "text-gray-400" : "text-gray-600"}`}>
          {effectiveShowAll ? `All ${totalTips} tips` : `Top ${minTips} tips`}
        </span>
        <Switch
          checked={effectiveShowAll}
          onCheckedChange={isLocked ? undefined : toggleTipsDisplay}
          aria-label={`Toggle between showing ${minTips} or ${totalTips} tips`}
          data-gtm-element-id="dashboard_tips_toggle"
          disabled={isLocked}
          className="data-[state=checked]:bg-emerald-500 data-[state=checked]:border-emerald-500"
        />
      </div>
      {isLocked && (
        <div className="flex items-center gap-1 text-xs text-gray-500">
          <Lock className="w-4 h-4" aria-hidden="true" />
          <span>{lockedMessage}</span>
        </div>
      )}
    </div>
  );
};

export default TipsDisplayToggle;
